import React from "react";
import "./TextareaInput.css";
import { useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";

// Live "used/max" counter shown under the textarea when a maxLength is set
const CharCounter = ({ control, name, maxLength }) => {
  const value = useWatch({ control, name }) || "";
  const atLimit = value.length >= maxLength;
  return (
    <div style={{ textAlign: "right", fontSize: 11, marginTop: 2, color: atLimit ? "#dc2626" : "#94a3b8" }}>
      {value.length}/{maxLength}
    </div>
  );
};

const TextareaInput = ({
  name,
  errors,
  register,
  label,
  type,
  mandatory,
  value,
  disabled = false,
  maxLength,
  control,
}) => {
  const { onChange, ...registerParams } = register(name);
  const { t } = useTranslation();
  return (
    <div className="input_text-form">
      <label>
        {t(label)}
        {mandatory && <span className="asterisk">*</span>}
      </label>
      <textarea

        autoComplete="off"
        className={`form_text_area form-control branch-input-form-control ${errors[name] ? "error__border--color" : "form_text_area form-control branch-input-form-control"
          }`}
        type={type}
        onChange={(event) => {
          onChange(event);
        }}
        {...registerParams}
        maxLength={maxLength}
        disabled={disabled}
      />
      {maxLength && control && <CharCounter control={control} name={name} maxLength={maxLength} />}
      <div className="error__message">{errors[name]?.message}</div>
    </div>
  );
};

export default TextareaInput;
